import { config } from '../Constants';

export const instructionVideos = {
    verbalInstructions: config.url.CDN_URL + '/Verbal/videos/gifted_verbal_instructions_v3.mp4',
    nonVerbalInstructionsPreK: config.url.CDN_URL + '/NonVerbal/videos/gifted_instructions_pre-k_1_rv2.mp4',
    nonVerbalInstructionsBD: config.url.CDN_URL + '/NonVerbal/videos/gifted_instructions_B-D_1.mp4',
    nonVerbalInstructionsEG: config.url.CDN_URL + '/NonVerbal/videos/gifted_instructions_E-G_1.mp4',
    quantInstructionsBD: config.url.CDN_URL + '/Quant/videos/gifted_quant_instructions_prek_B-D_v2.mp4',
    quantInstructionsEG: config.url.CDN_URL + '/Quant/videos/gifted_quant_instructions_E-G.mp4'
};